import { useQuery } from "@tanstack/react-query"
import { useParams } from 'react-router-dom';
import { getModuleDetails } from "../../../api/module"

const useGetModuleDetails = () => {
    const params = useParams()
    return useQuery({
        queryKey: ["ModuleDetail", params?.id],
        queryFn: () => getModuleDetails(params?.id)
    })
}

export default useGetModuleDetails;